import { render, staticRenderFns } from "./GenerateIdentityTableModal.vue?vue&type=template&id=3bb836bb&scoped=true&"
import script from "./GenerateIdentityTableModal.vue?vue&type=script&lang=js&"
export * from "./GenerateIdentityTableModal.vue?vue&type=script&lang=js&"
import style0 from "./GenerateIdentityTableModal.vue?vue&type=style&index=0&id=3bb836bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb836bb",
  null
  
)

export default component.exports